<template>
  <date-range-picker
    ref="picker"
    style="width:300px;"
    format="YYYY-DD-MM"
    v-model=currentDate
    :locale-data="{
      applyLabel: $lang.messages.apply,
      cancelLabel: $lang.messages.cancel_btn_text,
    }"
    :ranges="{
      [$lang.messages.today]: [moment(), moment()],
      [$lang.messages.yesterday]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      [$lang.messages.this_month]: [moment().startOf('month'), moment().endOf('month')],
      [$lang.messages.this_year]: [moment().startOf('year'), moment().endOf('year')],
      [$lang.messages.last_week]: [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
      [$lang.messages.last_month]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }"
    @update="onUpdate" />
</template>
<script>

import DateRangePicker from "vue2-daterange-picker"
import "vue2-daterange-picker/dist/vue2-daterange-picker.css"
import moment from 'moment'

export default {
  name: "CustomerDateRangePicker",
  components: {
    DateRangePicker
  },
  data() {
    const today = new Date();
    return {
      currentDate: {
        startDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          -6
        ),
        endDate: today
      }
    }
  },
  props: {
    date: {
      type: Object,
      require: true
    }
  },
  methods: {
    moment: function () {
      return moment();
    },

    onUpdate() {
      this.$emit('update:date', this.currentDate)
      this.$emit('update')
    }
  },

  created() {
    this.$emit('update:date', this.currentDate)
  }
}
</script>
